import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import LinearWithAriaValueText from './LinearWithAriaValueText';
import ClientProvider from './client';
export default createDemo(import.meta.url, LinearWithAriaValueText, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/progress/demos/linear-with-aria-value-text/LinearWithAriaValueText.tsx",
    "fileName": "LinearWithAriaValueText.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport LinearProgress from '@mui/material/LinearProgress';\nimport type { LinearProgressProps } from '@mui/material/LinearProgress';\nimport Typography from '@mui/material/Typography';\nimport Box from '@mui/material/Box';\n\ntype LinearProgressWithLabelAndValueProps = LinearProgressProps & {\n  min: number;\n  max: number;\n  value: number;\n};\n\nfunction LinearProgressWithLabelAndValue({\n  max,\n  min,\n  value,\n  ...rest\n}: LinearProgressWithLabelAndValueProps) {\n  const progressText = `Elevator at floor ${value} out of ${max}.`;\n  const progressId = React.useId();\n  return (\n    <div>\n      <Typography\n        id={progressId}\n        variant=\"body2\"\n        color=\"text.secondary\"\n        sx={{ mr: 1 }}\n      >\n        Elevator status\n      </Typography>\n      <Box sx={{ display: 'flex', alignItems: 'center' }}>\n        <Box sx={{ width: '100%', mr: 1 }}>\n          <LinearProgress\n            variant=\"determinate\"\n            aria-labelledby={progressId}\n            aria-valuetext={progressText}\n            min={min}\n            max={max}\n            value={value}\n            {...rest}\n          />\n        </Box>\n        <Box sx={{ whiteSpace: 'nowrap' }}>\n          <Typography variant=\"body2\" sx={{ color: 'text.secondary' }}>\n            {progressText}\n          </Typography>\n        </Box>\n      </Box>\n    </div>\n  );\n}\n\nexport default function LinearWithAriaValueText() {\n  const [progress, setProgress] = React.useState(1);\n\n  React.useEffect(() => {\n    const timer = setInterval(() => {\n      setProgress((prevProgress) => (prevProgress >= 10 ? 1 : prevProgress + 1));\n    }, 800);\n    return () => {\n      clearInterval(timer);\n    };\n  }, []);\n\n  return (\n    <Box sx={{ width: '100%' }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <LinearProgressWithLabelAndValue value={progress} min={1} max={10} />\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 70,
        "focusedLines": 1,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport LinearProgress from '@mui/material/LinearProgress';\nimport type { LinearProgressProps } from '@mui/material/LinearProgress';\nimport Typography from '@mui/material/Typography';\nimport Box from '@mui/material/Box';\n\ntype LinearProgressWithLabelAndValueProps = LinearProgressProps & {\n  min: number;\n  max: number;\n  value: number;\n};\n\nfunction LinearProgressWithLabelAndValue({\n  max,\n  min,\n  value,\n  ...rest\n}: LinearProgressWithLabelAndValueProps) {\n  const progressText = `Elevator at floor ${value} out of ${max}.`;\n  const progressId = React.useId();\n  return (\n    <div>\n      <Typography\n        id={progressId}\n        variant=\"body2\"\n        color=\"text.secondary\"\n        sx={{ mr: 1 }}\n      >\n        Elevator status\n      </Typography>\n      <Box sx={{ display: 'flex', alignItems: 'center' }}>\n        <Box sx={{ width: '100%', mr: 1 }}>\n          <LinearProgress\n            variant=\"determinate\"\n            aria-labelledby={progressId}\n            aria-valuetext={progressText}\n            min={min}\n            max={max}\n            value={value}\n            {...rest}\n          />\n        </Box>\n        <Box sx={{ whiteSpace: 'nowrap' }}>\n          <Typography variant=\"body2\" sx={{ color: 'text.secondary' }}>\n            {progressText}\n          </Typography>\n        </Box>\n      </Box>\n    </div>\n  );\n}\n\nexport default function LinearWithAriaValueText() {\n  const [progress, setProgress] = React.useState(1);\n\n  React.useEffect(() => {\n    const timer = setInterval(() => {\n      setProgress((prevProgress) => (prevProgress >= 10 ? 1 : prevProgress + 1));\n    }, 800);\n    return () => {\n      clearInterval(timer);\n    };\n  }, []);\n\n  return (\n    <Box sx={{ width: '100%' }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <LinearProgressWithLabelAndValue value={progress} min={1} max={10} />\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 67
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "LinearProgressWithLabelAndValue"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "value"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "progress"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "min"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "1"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "max"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "10"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " />"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 70,
    "focusedLines": 1,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/LinearProgress",
      "@mui/material/Typography",
      "@mui/material/Box"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
